/** @format */
import pro1 from "../assets/project1.png";
import pro2 from "../assets/project2.png";
import pro3 from "../assets/project3.png";
const ProjectCardData = [
	{
		imgsrc: pro1,
		title: " Todo App",
		text: "This app is a Todo app with all the crud operations and has a wide varitied of themes intergrated in it.",
		view: "https://taskmatereactapp.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/todoadvancedreactapp",
	},
	// source
	{
		imgsrc: pro2,
		title: "Cinemate App",
		text: " This app is a Netflix clone using react js it has various features in it like imdb ratings and dark mode.",
		view: "https://cinemate-ul.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/moviereactapp",
	},
	{
		imgsrc: pro3,
		title: "Weather App",
		text: " This is a app used for weather detection in that particular area by location or by using maps it has a various features in it.",
		view: "https://weatherappbyreact.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/weather-app-",
	},
	{
		imgsrc: pro3,
		title: "TextUtils App",
		text: " This is a app used for text editors according to our needs to do operations and has many functionalities in it.",
		view: "https://textutilappfortext.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/Textutilapp",
	},
	{
		imgsrc: pro3,
		title: "Mp3 Converter React App",
		text: " This is a app used for converting the youbube videos into mp3 format and has a downloading feature in it.",
		view: "https://youtubemp3convertor.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/youtubetomp3convertor",
	},
	{
		imgsrc: pro3,
		title: "Searchpics App",
		text: " This app is used when a search is performed then it shows the image related to the search item",
		view: "https://searchpicsapp.netlify.app/",
		src: "https://github.com/SaurabhTiwari123-juet/searchpicsapp-using-react",
	},
];

export default ProjectCardData;
